import { ChangeDetectionStrategy, Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ICONS } from '@nimbus-library/features/shared/resources/icons';
import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';
import { MenuEntryViewModel } from '@nimbus-library/features/menu/models/menu-entry.view-model';
import { Feature } from '@nimbus-global/features/feature-flipping/feature.enum';
import { FeatureFlippingService } from '@nimbus-global/features/feature-flipping/feature-flipping.service';
import { CompanionSplitScreenService } from '@nimbus-library/features/companion-chat/services/companion-split-screen.service';
import { MenuItemComponent } from '../menu-item/menu-item.component';

@Component({
  standalone: false,
  selector: 'nimbus-companion-menu-item',
  templateUrl: './companion-menu-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanionMenuItemComponent implements OnInit {
  @ViewChild(MenuItemComponent)
  private menuItem: MenuItemComponent;

  @Input()
  public entry: MenuEntryViewModel;

  public readonly TranslationKeys = TranslationKeys;
  public readonly ICONS = ICONS;

  public isSplitScreenEnabled$: Observable<boolean>;

  public constructor(
    private readonly router: Router,
    private readonly featureFlippingService: FeatureFlippingService,
    private readonly companionSplitScreenService: CompanionSplitScreenService,
  ) {}

  public ngOnInit(): void {
    this.isSplitScreenEnabled$ = this.featureFlippingService.isEnabledInFeatureManagement(Feature.CompanionConversationSplitScreen);
  }

  public navigateFullScreen(): void {
    this.menuItem.close();
    this.router.navigate([this.entry.path]);
  }

  public navigateSplitScreen(): void {
    this.menuItem.close();
    this.companionSplitScreenService.activate({ conversationId: null, messages: [] });
    this.router.navigate(['/']);
  }
}
